import script from "./Col.vue?vue&type=script&setup=true&lang=js"
export * from "./Col.vue?vue&type=script&setup=true&lang=js"

import "./Col.vue?vue&type=style&index=0&id=b05818be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b05818be"]])

export default __exports__